import { render, staticRenderFns } from "./CompanyFacilitiesCounts.vue?vue&type=template&id=34a5e070&scoped=true"
import script from "./CompanyFacilitiesCounts.vue?vue&type=script&lang=js"
export * from "./CompanyFacilitiesCounts.vue?vue&type=script&lang=js"
import style0 from "./CompanyFacilitiesCounts.vue?vue&type=style&index=0&id=34a5e070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a5e070",
  null
  
)

export default component.exports